
// export default Accueil;
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef } from "react";
import './accueil.css';

import { useSelector, useDispatch } from 'react-redux';
import { setTopVolatiles } from '../../redux/marketSlice';
import { Link, useNavigate } from "react-router-dom";
import { getVirtualDatejeu, getArticles, getPortefeuilleData, checktransactionsPourDefiActif, getMarches, closeTransaction, getAllPendingTransactions, getAllTransactionsByStatus, getTopVolatilesMarches } from '../../Api/authApi.js.js';
import { toast, ToastContainer } from 'react-toastify';
import Pusher from 'pusher-js';
import { ShowVideoModal } from "../../components/ShowVideoModal/index.js";
import { formatPrice } from '../../functions/price-formater.js';
import CapitalChart from '../../components/chartgraphique/CapitalChart/index.js';

const AccueilJeu = () => {


    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [portefeuilledata, setportefeuilledata] = useState([]);
    const [articles, setArticles] = useState([]);
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const userId = useSelector((state) => state.auth.user.id);
    const topVolatilesCache = useSelector((state) => state.market.topVolatiles);
    const [defischeck, setdefischeck] = useState([]);
    const [selectedMarche, setSelectedMarche] = useState(null);
    const [marches, setMarches] = useState([]);
    const [marchesid, setMarchesid] = useState();
    const [leagueid, setLeagueid] = useState();
    const [dateJeu, setDateJeu] = useState(null);
    const [validMarches, setValidMarches] = useState([]);
    const [topVolatiles, setTopVolatilesState] = useState(topVolatilesCache.data);

    // ── Capital chart
    const [allTxs, setAllTxs] = useState([]);

    // ── Carousel
    const carouselRef = useRef(null);
    const getCardWidth = () => {
        if (window.innerWidth >= 1024) return 'calc(25% - 8px)';
        if (window.innerWidth >= 640)  return 'calc(33.33% - 7px)';
        return 'calc(50% - 5px)';
    };
    const [cardWidth, setCardWidth] = useState(getCardWidth);
    const [isTouch, setIsTouch] = useState(false);

    useEffect(() => {
        setIsTouch('ontouchstart' in window || navigator.maxTouchPoints > 0);
        const handler = () => setCardWidth(getCardWidth());
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, []);

    const scrollCarousel = (dir) => {
        if (!carouselRef.current) return;
        carouselRef.current.scrollBy({ left: dir * carouselRef.current.offsetWidth, behavior: 'smooth' });
    };

    useEffect(() => {
        const pusher = new Pusher('277b974b332c672e42b1', {
            cluster: 'eu',
        });

        const channel = pusher.subscribe('marches-valides');
        channel.bind('App\\Events\\MarcheValideUpdated', (data) => {
            // console.log('Mise à jour reçue :', data.validMarches);
            setValidMarches(data.validMarches);
        });

        return () => {
            pusher.disconnect();
        };
    }, []);

    useEffect(() => {
        const pusher = new Pusher('277b974b332c672e42b1', { cluster: 'eu' });
        const channel = pusher.subscribe(`user-transactions.${userId}`);

        channel.bind('transaction.updated', (data) => {
            if (data.type === 'defi') {
                // console.log('Défi mis à jour :', data);
                alert(data.message); // Ou mettez à jour votre interface
            }
        });

        return () => {
            channel.unbind('transaction.updated');
            pusher.unsubscribe(`user-transactions.${userId}`);
        };
    }, [userId]);


    const fetchPendingTransactions = async () => {
        try {
            const data = await getAllPendingTransactions(user.id);
            setTransactions(data.transactions_pending);
            // Mettre à jour les transactions avec les achats et ventes en attente
            // console.log('ff',data)
        } catch (error) {
            setError(error.message);
        }
    };

    useEffect(() => {
        fetchPendingTransactions(); // Appeler la fonction une fois lors du premier rendu
        const intervalId = setInterval(() => {
            fetchPendingTransactions();
        }, 4 * 60 * 1000); // Intervalle de 4 minutes en millisecondes

        // Nettoyer l'intervalle
        return () => clearInterval(intervalId);

    }, [user]);

    useEffect(() => {
        const checkDefis = async () => {
            try {
                const response = await checktransactionsPourDefiActif(userId);
                setdefischeck(response.valid_defis);
            } catch (error) {
                // silent
            }
        };
        checkDefis();
    }, []);
    useEffect(() => {
        const fetchMarches = async () => {
            try {
                setLoading(true);

                // 1. Récupérer les marchés de l'utilisateur
                const data = await getMarches(userId);
                setMarches(data);

                if (data.length > 0) {
                    let defaultMarche = data[0]; // Par défaut, utiliser le premier marché
                    let defaultLeagueId = defaultMarche.league_id; // Prendre le league_id du premier marché

                    // 2. Vérifiez si l'utilisateur a un league_id préféré
                    if (user && user.league_id) {
                        const preferredMarche = data.find(marche => marche.league_id === user.league_id);
                        if (preferredMarche) {
                            defaultMarche = preferredMarche;
                            defaultLeagueId = preferredMarche.league_id;
                        }
                    }

                    // 3. Mettre à jour les états avec les valeurs par défaut
                    setSelectedMarche(defaultMarche);
                    setMarchesid(defaultMarche.marche_id);
                    setLeagueid(defaultLeagueId);

                    // 4. Appeler getVirtualDatejeu avec leagueId
                    fetchVirtualDate(defaultLeagueId);
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        // Fonction pour récupérer la date virtuelle
        const fetchVirtualDate = async (leagueId) => {
            try {
                const response = await getVirtualDatejeu(leagueId);
                // console.log('Réponse reçue de l'API:', response);
                setDateJeu(response);
            } catch (err) {
                setError(err.message);
            }
        };

        // if (userId) {
        //     fetchMarches();
        // }
        if (userId) {
            // Appel initial
            fetchMarches();

            // Démarrer un intervalle pour exécuter périodiquement fetchMarches
            const intervalId = setInterval(() => {
                fetchMarches();
            }, 4 * 60 * 1000); // Intervalle de 4 minutes en millisecondes

            // Nettoyer l'intervalle à la fin
            return () => clearInterval(intervalId);
        }
    }, [userId, user]);



    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const articlesData = await getArticles();
                setArticles(articlesData);
                // console.log('articlesData', articlesData)
            } catch (err) {
                setError(err.message);
            }
        };

        fetchArticles();
    }, []);
    useEffect(() => {
        const fetchPortefeuilleData = async () => {
            try {
                const data = await getPortefeuilleData(user.id);
                setportefeuilledata(data);
                // console.log('getPortefeuilleData', data)

            } catch (error) {
                setError(error.message);
            }

        };

        fetchPortefeuilleData();
    }, [user]);

    useEffect(() => {
        getAllTransactionsByStatus(user.id)
            .then(res => setAllTxs(res.transactions || []))
            .catch(() => {});
    }, [user.id]);

    useEffect(() => {
        if (!userId) return;
        if (Date.now() - topVolatilesCache.at < 60_000) return;
        getTopVolatilesMarches(userId).then(data => {
            setTopVolatilesState(data);
            dispatch(setTopVolatiles(data));
        }).catch(() => {});
    }, [userId]);


    useEffect(() => {
        const fetchMarches = async () => {
            try {
                setLoading(true); // Assurez-vous que le chargement commence
                const data = await getMarches(userId); // Appel à l'API avec le user_id
                // console.log('marchés', data);

                setMarches(data);
                if (data.length > 0) {
                    setSelectedMarche(data[0]); // Sélectionnez le premier marché

                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (userId) {
            fetchMarches();
        }
    }, [userId]);

    const getCurrentGameDate = (dateStart, dateEnd) => {
        const startDate = new Date(dateStart);
        const endDate = new Date(dateEnd);
        const now = new Date();

        // Vérifier si la date actuelle est entre la date de début et la date de fin
        if (now >= startDate && now <= endDate) {
            const options = { year: 'numeric', month: 'long', day: 'numeric' }; // Format de date
            return now.toLocaleDateString('fr-FR', options); // Renvoie la date formatée si elle est dans l'intervalle
        }
        return ''; // Retourne vide si la date actuelle n'est pas dans l'intervalle
    };

    return (
        <div className="accueil-new w-full relative overflow-auto h-[100%]">
            <ShowVideoModal />

            {/* Greeting — pleine largeur */}
            <div style={{ padding: '20px 4px 12px' }} className="xl:my-4">
                <div style={{ color: 'var(--text-mute)', fontSize: 13, fontWeight: 500 }}>Bonjour,</div>
                <div style={{ fontSize: 22, fontWeight: 600, letterSpacing: '-0.015em' }} className="flex items-center justify-between md:justify-start md:gap-7 items-end">
                    {user?.username || 'Joueur'}{dateJeu ? <span className="text-xs relative top-[4px]" style={{ color: 'var(--text-mute)', fontSize: 13, fontWeight: 500 }}>{` Nous sommes le ${dateJeu.jour_virtuel} ${dateJeu.nom_mois_virtuel} ${dateJeu.annee_virtuelle}`}</span> : ''}
                </div>
            </div>

            {/* ── Grille haut : Capital (gauche) | Stats+CTA (droite) ── */}
            <div className="accueil-top-grid">

            {/* Colonne gauche : capital */}
            <div className="accueil-top-left">

            {/* Portfolio hero card */}
            <div className="relief" style={{ borderRadius: 24, padding: '20px 20px 8px', overflow: 'hidden' }}>
                <CapitalChart
                    portefeuilledata={portefeuilledata}
                    allTxs={allTxs}
                    dateJeu={dateJeu}
                    fullscreenHref="/full_screen/capital"
                />
            </div>

            </div>{/* fin colonne gauche */}

            {/* Colonne droite : stats + CTA */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

            {/* Stats row */}
            <div id="tuto-liquidite-positions" className="accueil-stats-grid">
                <div className="relief" style={{ borderRadius: 16, padding: '12px 14px' }}>
                    <div style={{ color: 'var(--text-mute)', fontSize: 11, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Liquidité</div>
                    <div className="num" style={{ marginTop: 4, fontSize: 18, fontWeight: 600, letterSpacing: '-0.015em' }}>
                        {portefeuilledata.liquidite !== undefined
                            ? formatPrice(portefeuilledata.liquidite)
                            : '—'}
                    </div>
                    {portefeuilledata.liquidite !== undefined && portefeuilledata.montant_actuel > 0 && (
                        <div style={{ color: 'var(--text-mute)', fontSize: 11, marginTop: 2 }}>
                            {((portefeuilledata.liquidite / portefeuilledata.montant_actuel) * 100).toFixed(1)}% du capital
                        </div>
                    )}
                </div>
                <div className="relief" style={{ borderRadius: 16, padding: '12px 14px' }}>
                    <div style={{ color: 'var(--text-mute)', fontSize: 11, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Positions</div>
                    <div className="num" style={{ marginTop: 4, fontSize: 18, fontWeight: 600, letterSpacing: '-0.015em' }}>
                        {(transactions || []).length}
                    </div>
                    <div style={{ color: 'var(--text-mute)', fontSize: 11, marginTop: 2 }}>
                        {formatPrice((transactions || []).reduce((sum, t) => sum + (parseFloat(t.montant) || 0), 0))} investis
                    </div>
                </div>
            </div>

            {/* Investir CTA */}
            <Link to='/portefeuille_menu' style={{ display: 'block', textDecoration: 'none' }}>
                <button className="pill-tap" style={{
                    width: '100%',
                    height: 54, borderRadius: 16,
                    background: 'linear-gradient(180deg, #ffffff 0%, #e3e8f1 100%)',
                    color: '#0A1226',
                    border: 'none',
                    fontWeight: 700, fontSize: 15, letterSpacing: '-0.005em',
                    cursor: 'pointer',
                    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.9), 0 6px 18px rgba(0,0,0,0.4), 0 1px 0 rgba(255,255,255,0.06)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                }}>
                    <svg width="16" height="16" viewBox="0 0 16 16">
                        <path d="M8 3v10M3 8h10" stroke="#0A1226" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    Investir
                </button>
            </Link>

            </div>{/* fin colonne droite */}
            </div>{/* fin accueil-top-grid */}

            {/* ===== Défis du jour ===== */}
            <div id="tuto-defis-section" className="xl:my-8">
                <div className="accueil-defis-header">
                    <h2 style={{ margin: 0, fontSize: 16, fontWeight: 600, letterSpacing: '-0.01em' }}>Défis du jour</h2>
                    {defischeck.length > 0 && (
                        <span style={{ fontSize: 11, color: 'var(--gold)', fontWeight: 600 }}>
                            + {formatPrice(defischeck.reduce((sum, d) => sum + (parseFloat(d.montant_gagner) || 0), 0))} à gagner
                        </span>
                    )}
                </div>
                <div className="accueil-defis-list">
                    {defischeck.length === 0 && (
                        <div className="relief" style={{ borderRadius: 14, padding: '20px 16px', textAlign: 'center', color: 'var(--text-mute)', fontSize: 12.5 }}>
                            Pas encore de défi disponible. Reviens un peu plus tard !
                        </div>
                    )}
                    {defischeck.map((item) => {
                        const done = item.defi_atteint;
                        const rewardAmount = formatPrice(item.montant_gagner);
                        return (
                            <div key={item.id} className="relief" style={{
                                borderRadius: 14, padding: '12px 14px',
                                display: 'grid', gridTemplateColumns: '36px 1fr auto', gap: 12, alignItems: 'center',
                            }}>
                                {done ? (
                                    <div style={{
                                        width: 36, height: 36, borderRadius: 11, flexShrink: 0,
                                        background: 'var(--up-soft)',
                                        border: '1px solid rgba(74,222,158,0.3)',
                                        color: 'var(--up)',
                                        display: 'grid', placeItems: 'center',
                                    }}>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M3 8l4 4 6-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </div>
                                ) : (
                                    <div style={{
                                        width: 36, height: 36, borderRadius: 11, flexShrink: 0,
                                        background: 'var(--gold-soft)',
                                        border: '1px solid rgba(224,194,129,0.3)',
                                        color: 'var(--gold)',
                                        display: 'grid', placeItems: 'center',
                                    }}>
                                        <span style={{ fontSize: 11, fontWeight: 700, lineHeight: 1 }}>
                                            {(item.transactions_traitees || []).length}/{item.objectif_total ?? '?'}
                                        </span>
                                    </div>
                                )}

                                <div style={{ minWidth: 0 }}>
                                    <div style={{ fontSize: 13, fontWeight: 600, lineHeight: 1.25 }}>{item.titre_defis}</div>
                                    <div style={{ marginTop: 8, height: 3, borderRadius: 2, background: 'rgba(255,255,255,0.06)', overflow: 'hidden' }}>
                                        <div style={{
                                            width: done ? '100%' : '0%', height: '100%',
                                            background: done ? 'var(--up)' : 'var(--gold)',
                                            borderRadius: 2,
                                            transition: 'width 0.6s ease',
                                        }}/>
                                    </div>
                                </div>

                                {rewardAmount && (
                                    <div style={{
                                        color: 'var(--gold)', fontSize: 11, fontWeight: 700,
                                        background: 'var(--gold-soft)', padding: '3px 7px', borderRadius: 6,
                                        whiteSpace: 'nowrap',
                                    }}>+{rewardAmount}</div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* ===== Ça bouge aujourd'hui ===== */}
            {topVolatiles.length > 0 && (
                <div className="xl:my-4" style={{ maxWidth: '500px' }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', padding: '20px 4px 10px' }}>
                        <h2 style={{ margin: 0, fontSize: 16, fontWeight: 600, letterSpacing: '-0.01em' }}>Ça bouge aujourd'hui</h2>
                        <Link to="/portefeuille_menu" style={{
                            background: 'none', border: 'none', fontSize: 12, color: 'var(--text-dim)',
                            fontWeight: 500, textDecoration: 'none',
                        }}>Tout voir</Link>
                    </div>
                    <div className="relief" style={{ borderRadius: 18, padding: '4px 14px' }}>
                        {topVolatiles.map((m, i) => (
                            <VolatileMarketRow
                                key={m.marche_id}
                                marche={m}
                                isLast={i === topVolatiles.length - 1}
                            />
                        ))}
                    </div>
                </div>
            )}

            {/* ===== Apprendre ===== */}
            <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', padding: '20px 4px 10px' }}>
                <h2 style={{ margin: 0, fontSize: 16, fontWeight: 600, letterSpacing: '-0.01em' }}>Apprendre</h2>
            </div>
            {articles.length === 0 ? (
                <p style={{ color: 'var(--text-mute)', fontSize: 13 }}>Aucun article disponible.</p>
            ) : (
                <div style={{ position: 'relative' }}>
                    {/* Flèche gauche — non-tactile uniquement */}
                    {!isTouch && (
                        <button
                            onClick={() => scrollCarousel(-1)}
                            aria-label="Précédent"
                            style={{
                                position: 'absolute', top: '50%', transform: 'translateY(-50%)',
                                left: -18, zIndex: 2,
                                width: 36, height: 36, borderRadius: '50%',
                                background: 'rgba(10,18,48,0.88)',
                                backdropFilter: 'blur(8px)',
                                border: '1px solid rgba(255,255,255,0.12)',
                                color: '#F2F5FB', cursor: 'pointer',
                                display: 'grid', placeItems: 'center', padding: 0,
                                boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
                            }}
                        >
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M9 2L4 7l5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    )}

                    <div id="tuto-apprendre-section" ref={carouselRef} className="hide-scrollbar" style={{
                        display: 'flex', gap: 10,
                        overflowX: 'auto',
                        scrollSnapType: 'x mandatory',
                        WebkitOverflowScrolling: 'touch',
                    }}>
                        {articles.map((item) => (
                            <Link
                                key={item.id}
                                to={`/article/${item.id}`}
                                className="accueil-learn-card"
                                style={{
                                    flex: `0 0 ${cardWidth}`,
                                    textDecoration: 'none',
                                    borderRadius: 16,
                                    overflow: 'hidden',
                                    position: 'relative',
                                    height: 160,
                                    border: '1px solid rgba(255,255,255,0.07)',
                                    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05), 0 4px 12px rgba(0,0,0,0.3)',
                                    display: 'block',
                                }}
                            >
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    style={{
                                        position: 'absolute', inset: 0,
                                        width: '100%', height: '100%',
                                        objectFit: 'cover',
                                    }}
                                />
                                <div style={{
                                    position: 'absolute', inset: 0,
                                    background: 'linear-gradient(to top, rgba(10,18,38,0.92) 0%, rgba(10,18,38,0.35) 55%, transparent 100%)',
                                }}/>
                                <div style={{
                                    position: 'absolute', bottom: 0, left: 0, right: 0,
                                    padding: '10px 12px 14px',
                                }}>
                                    <div style={{
                                        fontSize: 12, fontWeight: 700, lineHeight: 1.3,
                                        color: '#F2F5FB',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        overflow: 'hidden',
                                    }}>{item.title}</div>
                                </div>
                            </Link>
                        ))}
                    </div>

                    {/* Flèche droite */}
                    {!isTouch && (
                        <button
                            onClick={() => scrollCarousel(1)}
                            aria-label="Suivant"
                            style={{
                                position: 'absolute', top: '50%', transform: 'translateY(-50%)',
                                right: -18, zIndex: 2,
                                width: 36, height: 36, borderRadius: '50%',
                                background: 'rgba(10,18,48,0.88)',
                                backdropFilter: 'blur(8px)',
                                border: '1px solid rgba(255,255,255,0.12)',
                                color: '#F2F5FB', cursor: 'pointer',
                                display: 'grid', placeItems: 'center', padding: 0,
                                boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
                            }}
                        >
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M5 2l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                    )}
                </div>
            )}

        </div>
    )
};

function AccueilSparkline({ data, up }) {
    if (!data || data.length < 2) return <div style={{ width: 56, height: 22, flexShrink: 0 }}/>;
    const min = Math.min(...data);
    const max = Math.max(...data);
    const range = max - min || 1;
    const W = 56, H = 22;
    const stepX = W / (data.length - 1);
    const pts = data.map((v, i) => [i * stepX, H - ((v - min) / range) * H]);
    const path = pts.map((p, i) => `${i ? 'L' : 'M'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');
    const area = `${path} L${W},${H} L0,${H} Z`;
    const color = up ? '#4ADE9E' : '#FF7A78';
    const gradId = `acc-sp-${data.length}-${Math.round(data[0])}`;
    return (
        <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} style={{ display: 'block', flexShrink: 0 }}>
            <defs>
                <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor={color} stopOpacity="0.3"/>
                    <stop offset="100%" stopColor={color} stopOpacity="0"/>
                </linearGradient>
            </defs>
            <path d={area} fill={`url(#${gradId})`}/>
            <path d={path} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round"/>
        </svg>
    );
}

function VolatileMarketRow({ marche, isLast }) {
    const navigate = useNavigate();
    const value = marche.value != null ? parseFloat(marche.value) : null;
    const pct   = marche.variation_pct != null ? parseFloat(marche.variation_pct) : null;
    const up    = pct !== null ? pct >= 0 : true;

    return (
        <button
            onClick={() => navigate('/portefeuille_menu')}
            className="pill-tap"
            style={{
                display: 'flex', alignItems: 'center', gap: 12,
                width: '100%', background: 'none', border: 'none', cursor: 'pointer',
                padding: '12px 0', textAlign: 'left',
                borderBottom: isLast ? 'none' : '1px solid var(--border)',
            }}
        >
            <div style={{
                width: 40, height: 40, borderRadius: 12, flexShrink: 0,
                background: 'rgba(255,255,255,0.05)',
                border: '1px solid var(--border)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                overflow: 'hidden',
                boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05)',
            }}>
                {marche.icon ? (
                    <img src={marche.icon} alt={marche.titre} loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 11 }}/>
                ) : (
                    <span style={{ color: 'var(--text-dim)', fontWeight: 700, fontSize: 12 }}>
                        {marche.titre?.slice(0, 2).toUpperCase()}
                    </span>
                )}
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {marche.titre}
                </div>
                <div style={{ fontSize: 11, color: 'var(--text-mute)', fontWeight: 500, marginTop: 2 }}>
                    {marche.type}
                </div>
            </div>
            <AccueilSparkline data={marche.sparkline} up={up}/>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', flexShrink: 0, gap: 3 }}>
                {value != null ? (
                    <>
                        <span className="num" style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)' }}>
                            {value.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </span>
                        {pct !== null && (
                            <span className="num" style={{ fontSize: 11, fontWeight: 600, color: up ? 'var(--up)' : 'var(--down)' }}>
                                {pct >= 0 ? '+' : ''}{pct.toFixed(2)} %
                            </span>
                        )}
                    </>
                ) : (
                    <span style={{ fontSize: 11, color: 'var(--text-mute)' }}>…</span>
                )}
            </div>
        </button>
    );
}

// Ligue terminée : plus aucune fonctionnalité de jeu, uniquement le message de fin.
const AccueilJeuTermine = () => {
    const username = useSelector((state) => state.auth.user?.username);

    return (
        <div className="accueil-new w-full relative overflow-auto h-[100%]">
            <div style={{ padding: '20px 4px 12px' }} className="xl:my-4">
                <div style={{ color: 'var(--text-mute)', fontSize: 13, fontWeight: 500 }}>Bonjour,</div>
                <div style={{ fontSize: 22, fontWeight: 600, letterSpacing: '-0.015em' }}>
                    {username || 'Joueur'}
                </div>
            </div>
            <div className="flex">
                <div className="relief" style={{ borderRadius: 24, padding: '20px 25px', fontSize: 15, lineHeight: 1.5 }}>
                    <div className="text-2xl">Le jeu est terminé,</div>
                    <div className="mt-2">rapprochez vous de votre professeur afin de retrouver votre classement.</div>
                    <div className="mt-2">Bravo à ceux qui ont su performer !</div>
                </div>
            </div>
        </div>
    );
};

const Accueil = () => {
    const leagueArchived = useSelector((state) => state.auth.user?.league_archived);
    return leagueArchived ? <AccueilJeuTermine /> : <AccueilJeu />;
};

export default Accueil;
